/**
 * API очереди модерации компаний-партнёров (DEV-795) поверх сгенерированного
 * agentsServiceApi. Менеджерская поверхность: список на приёме, карточка, приём.
 * RBAC («свои vs все», agents:read/agents:manage) решает бэкенд по роли.
 */
import { agentsServiceApi } from '@/api'
import { mapVerificationFromAPI } from '../mappers/companyVerification.mapper'
import type {
  CompanyVerification,
  PaginatedVerifications,
  VerificationDecision,
  VerificationFilter,
} from '../types/companyVerification.types'

export const companyVerificationsApi = {
  /**
   * Список верификаций с пагинацией. Сервер принимает только verificationStatus /
   * responsibleId / agentUserId (см. VerificationFilter); search/minConfidence —
   * клиентская фильтрация на уровне стора (follow-up: расширить серверные параметры).
   */
  async list(
    filter: VerificationFilter,
    page: number,
    perPage: number,
  ): Promise<PaginatedVerifications> {
    const { data } = await agentsServiceApi.agentsServiceListCompanyVerifications(
      String(page),
      String(perPage),
      filter.verificationStatus || undefined,
      filter.responsibleId || undefined,
      filter.agentUserId || undefined,
    )
    return {
      items: (data.verifications ?? []).map(mapVerificationFromAPI),
      total: Number(data.pagination?.total ?? 0),
      page: Number(data.pagination?.page ?? page),
      perPage: Number(data.pagination?.perPage ?? perPage),
    }
  },

  /** Одна запись верификации (для модалки приёма). */
  async get(id: string): Promise<CompanyVerification> {
    const { data } = await agentsServiceApi.agentsServiceGetCompanyVerification(id)
    return mapVerificationFromAPI(data.verification ?? {})
  },

  /**
   * Приём менеджером. decision: accept (компания → active, агент manual_confirmed) |
   * private (частный агент, private_agent_confirmed) | correct (исправить выбор,
   * override_reason обязателен).
   */
  async confirmByManager(
    id: string,
    decision: VerificationDecision,
    selectedCompanyId?: string,
    overrideReason?: string,
  ): Promise<CompanyVerification> {
    const { data } = await agentsServiceApi.agentsServiceConfirmCompanyAssignmentByManager(id, {
      decision,
      selectedCompanyId: selectedCompanyId || undefined,
      overrideReason: overrideReason || undefined,
    })
    return mapVerificationFromAPI(data.verification ?? {})
  },
}
